module.exports = __webpack_public_path__ + "img/pending.16c7e641.svg";